import { render, staticRenderFns } from "./BaikeList.vue?vue&type=template&id=369930c4&scoped=true&"
import script from "./BaikeList.vue?vue&type=script&lang=js&"
export * from "./BaikeList.vue?vue&type=script&lang=js&"
import style0 from "./BaikeList.vue?vue&type=style&index=0&id=369930c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369930c4",
  null
  
)

export default component.exports